import styled from "styled-components";

import { ActiveOrdersPreviewStyledProps as Props } from "./ActiveOrdersPreview.types";
import { ActiveOrdersPreviewPlaceholderProps as PlaceholderProps } from "./ActiveOrdersPreview.types";
import CONSTANTS from "config/constants";

const { BREAKPOINTS } = CONSTANTS;
const { desktop, tablet, mobile } = BREAKPOINTS;

const ActiveOrdersPreviewStyled = styled.div<Props>`
  background-color: var(--palette-white);
  border-radius: 0.4rem;
  margin-bottom: ${props => (props.isEmpty ? "0" : "1.2rem")};

  @media (max-width: ${tablet}px) {
    padding: 0;
    border-radius: 2.4rem;
    border: 0;
  }

  .ActiveOrdersPreview {
    &__header {
      display: flex;
      width: 100%;
      justify-content: space-between;
      padding: ${props => (props.isEmpty ? "0 1.2rem" : "1.6rem")};
      padding-top: ${props => (props.isEmpty ? "2rem" : "1.2rem")};
      cursor: pointer;
      background-color: ${props =>
        props.active ? "var(--palette-black-h60-s25-l2-a10)" : "transparent"};
      padding-bottom: ${props => (props.isEmpty ? "1.6rem" : "1.2rem")};
      border-top-right-radius: 0.8rem;
      border-bottom-right-radius: 0.8rem;

      @media (max-width: ${tablet}px) {
        padding: ${props => (props.isEmpty ? "0" : "2rem 1.2rem")};
        padding-top: ${props => (props.isEmpty ? "1.6rem" : "1.2rem")};
        padding-bottom: ${props => (props.isEmpty ? "1.6rem" : "1.2rem")};
        padding-left: 1.2rem;
        padding-right: 1.2rem;
      }
    }

    &__title {
      font-size: 1.6rem;
      display: flex;
      align-items: center;
      color: ${props =>
        props.active ? "var(--palette-white)" : "var(--palette-black-s0-l10)"};
      line-height: 2.4rem;
      font-weight: 600;

      svg {
        margin-right: 2rem;
      }

      path {
        fill: ${props =>
          props.active
            ? "var(--palette-white)"
            : "var(--palette-black-s0-l10)"};
      }

      &--black {
        color: var(--palette-black-s0-l10);
      }
    }

    &__badge {
      display: inline-flex;
      align-items: center;
      display: ${props => (props.isEmpty ? "none" : "flex")};

      .Badge__value {
        position: static;
        width: 2.4rem;
        height: 2.4rem;
        font-size: 1.6rem;
        line-height: 2rem;
        z-index: 0;
        color: var(--palette-gray-s0-l97);
        padding: 0.4rem;
        border-radius: 2.4rem;
        font-weight: 700;
      }

      svg {
        width: 2.4rem;
        height: 2.4rem;
        margin-left: 0.4rem;
        cursor: pointer;
      }

      path {
        fill: ${props =>
          props.active
            ? "var(--palette-white)"
            : "var(--palette-black-s0-l10)"};
      }
    }

    &__card {
      border-radius: 0.4rem;
      padding: 0.8rem 1.2rem;
      position: relative;
      display: ${props => (props.isEmpty ? "none" : "block")};

      &__description {
        color: var(--palette-gray-s0-l35);
        font-size: 1.4rem;
        line-height: 1.6rem;
        font-weight: 700;
        padding: 0.4rem 0;

        @media (max-width: ${desktop - 1}px) {
          font-size: 1.2rem;
        }
      }

      &__description-delivery {
        text-transform: capitalize;
      }

      &__total {
        padding-top: 0.4rem;
        padding-bottom: 1.4rem;
      }
    }

    &__product-price-info {
      font-size: 1.4rem;
      line-height: 1.8rem;

      .ProductBasePriceInfo {
        &--normal {
          color: var(--palette-primary);
          font-weight: 600;
        }
      }

      @media (max-width: ${mobile}px) {
        font-size: 1.2rem;
      }
    }

    &__buttons {
      display: flex;
      justify-content: space-between;
    }

    &__button {
      font-size: 1.6rem;
      font-weight: 600;
      padding: 0.8rem 2rem;

      @media (max-width: ${mobile}px) {
        font-size: 1.4rem;
        padding: 0.8rem 1.2rem;
      }
    }

    &__pill-badge {
      color: var(--palette-primary);
      border: 0.1rem solid var(--palette-primary);
      font-weight: 600;
      font-size: 1.4rem;
      padding: 0.4rem 0.8rem;
      border-radius: 2rem;
      display: inline-block;
      text-align: center;
      display: flex;
      align-items: center;
    }
  }
`;

export const ActiveOrdersPreviewPlaceholderStyled = styled.div<PlaceholderProps>`
  margin-bottom: 2.4rem;
  padding: 0 1rem;

  .ActiveOrdersPreviewPlaceholder {
    &__wrapper {
      background-color: var(--palette-gray-s0-l95);
      border-radius: 0.4rem;
      height: 1.6rem;
      overflow: hidden;
      position: relative;
    }

    &__header {
      width: 20rem;
      margin-bottom: 2.4rem;
      margin-top: 2rem;
    }

    &__title {
      width: 10.4rem;
      margin-bottom: 1.2rem;
    }

    &__description {
      width: 24rem;
    }

    &__shine {
      animation: shine 2.5s ease-in-out infinite;
      background-color: var(--palette-gray-s0-l98);
      height: 300%;
      position: absolute;
      width: 25%;
      opacity: 0.4;
    }
  }
`;

export default ActiveOrdersPreviewStyled;
